module.exports = __webpack_public_path__ + "img/login_text.fb38c3a0.png";